module.exports = __webpack_public_path__ + "static/media/desktop_info.47bd5019.jpg";